import * as React from 'react';
import { Suspense } from 'react';
import { LoaderRow } from '../../mainv3/components/atoms/layout/LoaderRow';
import { ErrorBoundary } from '../components/atoms/boundaries';
import { ErrorPage } from '../../mainv3/containers/errors/ErrorPage';

export const lazyPage = (loader) => {
  const Component = React.lazy(loader);
  return (props) => (
    <ErrorBoundary
      fallback={
        <ErrorPage
          message={
            <span>
              申しわけありません😢
              <br />
              ページの読み込みに失敗しました。
            </span>
          }
        />
      }
    >
      <Suspense fallback={<LoaderRow />}>
        <Component {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
